<ng-template #pageHeaderOptions>
  <div class="page-header-toolbar">
    <div class="toolbar-row" *ngIf="access !== 'none' && collection">
      <div class="toolbar-flex-container">
        <div class="toolbar-button-container">
          <button mat-mini-fab color="primary" aria-label="reload collection" matTooltip="reload collection"
            (click)="callRefreshCollection()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <div class="toolbar-button-container" *ngIf="!isAnyModelInAddMode()">
          <button mat-raised-button color="primary" (click)="uploadModel()"
            [disabled]="isReadOnly() || uploadInProgress">
            <mat-icon>collections</mat-icon>
            <span>Upload Model</span></button>
          <mat-progress-spinner mode="indeterminate" *ngIf="uploadInProgress" diameter="20">
          </mat-progress-spinner>
        </div>
        <div class="toolbar-button-container" >
          <button mat-raised-button color="primary" (click)="onTimeline()" [disabled]="isReadOnly()">
            <mat-icon>history</mat-icon>
            <span>Collection Timeline</span></button>
        </div>
        <div class="toolbar-button-container" *ngIf="isRevisionView()">
          <button mat-raised-button color="primary" (click)="backToEditableCollection()">
            <mat-icon>edit</mat-icon>
            <span>Back to Parent Collection</span></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<mat-drawer-container class="drawer-container" autosize>
  <mat-drawer #drawer class="drawer-sidenav" [style.width.%]="modelTreeCollapserWidth" mode="side">
    <app-model-tree [modelToFiles]="modelToFiles" [retrievedFiles]="selectedModelToFiles" [forceSelectModelId]="modelTreeSelectedModelId"
      (modelsContextChange)="onModelContextChange($event)" (modelTypeChange)="onModelTypeChange($event)">
    </app-model-tree>
    <div class="drawer-resize-handle" 
         (mousedown)="onResizeStart($event)"
         title="Drag to resize">
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <ng-template *ngIf="!modelToFiles || modelToFiles?.length === 0">
      <div>
      </div>
      <div>
        <span *ngIf="access !== 'none';else no_access">no models found in this collection yet. please browse model
          folder
          for uploading a model</span>
        <ng-template #no_access>no access for the user to view this collection</ng-template>
      </div>
    </ng-template>
    <app-model-folders *ngIf="!!modelToFiles && modelToFiles.length > 0" [modelToFiles]="selectedModelToFiles" [modelType]="selectedModelType" [missingInputFiles]="missingInputFiles"
      (addFileToSimulation)="onAddFileToSimulation($event)" [isReadOnly]="isReadOnly()" [collection]="collection"
      (uploadFiles)="onUploadFiles($event)" (downloadModel)="onDownloadModel($event)" (enqueueDownloadModel)="onEnqueueDownloadModel($event)"></app-model-folders>
  </mat-drawer-content>
</mat-drawer-container>